module.exports = __webpack_public_path__ + "img/settings_background.132cf45d.svg";